<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6 mx-auto">
        <div class="img-success d-flex justify-content-center mx-auto">
          <img src="@/assets/img/bg/error-404.png" alt="Img" class="img-fluid" />
        </div>
        <div>
          <h1 class="text-center display-6 mb-2">404 Oops! Page Not Found</h1>
          <div class="text-center mb-4">
            <span class="text-gray fs-14"
              >This page doesn't exist or was removed! We suggest you back to home.</span
            >
          </div>
          <div class="d-flex justify-content-center">
            <router-link to="/home/" class="btn btn-dark d-flex align-items-center"
              ><i class="ti ti-circle-arrow-left me-1"></i>Back to Home</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
